// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BugTwoToneSvg from "@fishx/icons-svg/es/asn/BugTwoTone";
import FishxIcon from '../components/FishxIcon';

var BugTwoTone = function BugTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BugTwoToneSvg
  }));
};

BugTwoTone.displayName = 'BugTwoTone';
export default React.forwardRef(BugTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BugTwoTone.js
// module id = 2119
// module chunks = 0